import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'submission':
        return { name: 'CheckCircle2', color: 'var(--color-success)' };
      case 'abandoned':
        return { name: 'XCircle', color: 'var(--color-destructive)' };
      case 'started':
        return { name: 'PlayCircle', color: 'var(--color-primary)' };
      default:
        return { name: 'Circle', color: 'var(--color-muted-foreground)' };
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffMs = now - activityTime;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays}d ago`;
  };

  return (
    <div className="bg-card border border-border rounded-md shadow-elevation-sm">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-heading font-semibold text-foreground">
            Real-time Activity
          </h3>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse" />
            <span className="text-xs text-muted-foreground">Live</span>
          </div>
        </div>
      </div>
      <div className="divide-y divide-border max-h-96 overflow-y-auto scrollbar-custom">
        {activities?.map((activity) => {
          const icon = getActivityIcon(activity?.type);
          return (
            <div 
              key={activity?.id}
              className="p-4 hover:bg-muted/50 transition-smooth"
            >
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1">
                  <Icon name={icon?.name} size={20} color={icon?.color} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground mb-1">
                    {activity?.message}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-muted-foreground">
                    <span>{formatTimeAgo(activity?.timestamp)}</span>
                    <span>•</span>
                    <span className="capitalize">{activity?.device}</span>
                    {activity?.location && (
                      <>
                        <span>•</span>
                        <span>{activity?.location}</span>
                      </>
                    )}
                  </div>
                </div>
                <button className="flex-shrink-0 text-primary hover:text-primary/80 transition-smooth">
                  <Icon name="ExternalLink" size={16} />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivityFeed;